/**
 * Converts a base64 string to a File object.
 * @param base64String The base64 string to be converted.
 * @param fileName The name to give to the file.
 * @returns A File object.
 */
export const base64URLToFile = (
    base64String,
    fileName,
) => {
    if (typeof base64String === 'string') {
        const arr = base64String.split(',');
        const mime = arr[0].match(/:(.*?);/)?.[1] || '';
        const bstr = atob(arr[1]);
        let n = bstr.length;
        const u8arr = new Uint8Array(n);

        // eslint-disable-next-line no-plusplus
        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }

        return new File([u8arr], fileName, { type: mime });
    }

    return null;
};
